import type { TMember } from '@shared/types/member';
import type { TBankInfo } from '@shared/types/user';
import { number, object, string } from 'yup';

export const validationSchema = object({
  bank_name: string().required('Bank Name is required'),
  account_number: number().required('Account number is required'),
  account_name: string().required('Account Name is required'),
  bank_address: string().required('Bank Address is required'),
  swift_code: string().required('Swift code is required'),
  iban: string().nullable(),
  currency: string().required('Currency is required'),
});

export const generateBankFormInitialValue = (member: TMember): TBankInfo => ({
  id: member.bank_account?.id || 0,
  bank_name: member.bank_account?.bank_name || '',
  account_number: member.bank_account?.account_number || '',
  account_name: member.bank_account?.account_name || '',
  bank_address: member.bank_account?.bank_address || '',
  swift_code: member.bank_account?.swift_code || '',
  iban: member.bank_account?.iban || '',
  currency: member.bank_account?.currency || '',
});
